module.exports = __webpack_public_path__ + "static/media/october2024-2.c3ae3795.webp";